import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



  const cardData = {


  keyword: "Swift Dzire On Rent in Pune",

  headingDescription: "Trustline Cab provides reliable Swift Dzire on rent in Pune for local travel, airport transfers, corporate transportation, family trips, outstation journeys, and business travel. Maruti Swift Dzire is a popular sedan choice known for comfortable seating, good mileage, smooth driving experience, and affordable rental pricing. Whether you need a Swift Dzire for one day rental, multiple days, Pune to Mumbai travel, airport pickup and drop, one-way taxi, round trip, or sightseeing packages, our professional chauffeurs ensure a safe and comfortable journey. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, clean and well-maintained cars, flexible rental options, and 24/7 customer support, Trustline Travels is your trusted choice for Swift Dzire rental services in Pune.",

  topPlaces: [
    {
      title: "Mumbai Airport",
      description: "Mumbai Airport is a major destination for passengers traveling from Pune. Swift Dzire rental is a budget-friendly option for comfortable airport pickup and drop services with professional drivers and timely travel."
    },
    {
      title: "Andheri",
      description: "Andheri is one of Mumbai's busiest commercial areas, known for corporate offices, hotels, entertainment hubs, and excellent connectivity to Mumbai Airport. It is a common destination for Pune to Mumbai cab bookings."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's leading technology hub, home to multinational companies, software firms, and corporate campuses. Swift Dzire cabs are suitable for office travel and business transportation."
    },
    {
      title: "Kharadi",
      description: "Kharadi is Pune's major IT and commercial destination featuring EON IT Park, corporate offices, hotels, and business centers. It is a preferred location for professionals requiring reliable cab services."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly growing Pune suburb offering residential projects, commercial complexes, restaurants, and excellent connectivity to Hinjewadi and other major business areas."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is an important industrial and commercial region known for automobile companies, manufacturing units, engineering industries, and corporate offices."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a beautiful hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and scenic valleys. Swift Dzire rental is an affordable option for couples and small family trips."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a popular hill station near Pune known for strawberry farms, viewpoints, lakes, waterfalls, and pleasant weather. It is a preferred destination for weekend tours."
    },
    {
      title: "Panchgani",
      description: "Panchgani is a scenic hill station near Mahabaleshwar, famous for table land, beautiful valleys, viewpoints, and pleasant climate. It is a popular destination for peaceful vacations."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a coastal tourist destination near Mumbai known for beaches, forts, and relaxing getaways. It is a popular outstation destination for travelers looking for affordable cab services from Pune."
    }
  ],






"services": [
  {
    "name": "Swift Dzire on Rent in Pune",
    "description": "Book Swift Dzire on Rent in Pune for local travel, airport transfers, corporate trips, and outstation journeys with comfortable seating, AC vehicles, professional drivers, and affordable rental packages."
  },
  {
    "name": "Dzire on Rent for Outstation",
    "description": "Hire Dzire on Rent for Outstation travel with experienced chauffeurs, clean AC cars, transparent pricing, flexible packages, and comfortable long-distance journeys."
  },
  {
    "name": "Per Km Rate for Swift Dzire Cab",
    "description": "Check Per Km Rate for Swift Dzire Cab with transparent pricing, affordable packages, professional drivers, and reliable transportation options."
  },
  {
    "name": "Dzire Per Km Rate for Cab Booking",
    "description": "Get Dzire Per Km Rate for Cab Booking with flexible rental plans, fixed fares, comfortable vehicles, and easy online booking facilities."
  },
  {
    "name": "Swift Dzire Per Km Rate in Pune",
    "description": "Find Swift Dzire Per Km Rate in Pune for local and outstation travel with affordable fares, well-maintained cars, and professional chauffeur service."
  },
  {
    "name": "Swift Dzire Rent Per Km Rate for Outstation",
    "description": "Book Swift Dzire Rent Per Km Rate for Outstation trips with transparent charges, comfortable rides, and experienced drivers."
  },
  {
    "name": "Swift Dzire Rent Per Day",
    "description": "Hire Swift Dzire Rent Per Day in Pune for business travel, personal trips, city rides, and events with flexible rental durations."
  },
  {
    "name": "Swift Dzire Taxi Rate Per Km",
    "description": "Check Swift Dzire Taxi Rate Per Km with affordable pricing, AC comfort, professional drivers, and reliable cab services."
  },
  {
    "name": "Pune to Mahabaleshwar Swift Dzire Tour",
    "description": "Book Pune to Mahabaleshwar Swift Dzire Tour for comfortable hill station travel with experienced drivers, affordable fares, and safe journeys."
  },
  {
    "name": "Pune to Shirdi Swift Dzire Cab",
    "description": "Travel Pune to Shirdi with Swift Dzire Cab offering comfortable seating, professional chauffeurs, affordable pricing, and reliable pilgrimage transportation."
  },
  {
    "name": "Pune to Lonavala Swift Dzire Cab",
    "description": "Reserve Pune to Lonavala Swift Dzire Cab for weekend trips, family outings, and sightseeing with comfortable AC vehicles and experienced drivers."
  },
  {
    "name": "Pune to Ashtavinayak Swift Dzire Cab",
    "description": "Book Pune to Ashtavinayak Swift Dzire Cab for temple tours with flexible travel options, professional drivers, and comfortable transportation."
  },
  {
    "name": "Pune to Mumbai Airport Swift Dzire Cab",
    "description": "Hire Pune to Mumbai Airport Swift Dzire Cab for timely airport transfers with clean vehicles, fixed fares, and reliable chauffeur service."
  },
  {
    "name": "Pune to Goa Swift Dzire Hire",
    "description": "Book Pune to Goa Swift Dzire Hire for long-distance travel with comfortable seating, experienced drivers, and smooth highway journeys."
  },
  {
    "name": "Pune to Bhimashankar Swift Dzire Taxi",
    "description": "Travel Pune to Bhimashankar with Swift Dzire Taxi offering safe transportation, affordable fares, and professional driver assistance."
  },
  {
    "name": "Swift Dzire Taxi for Outstation",
    "description": "Choose Swift Dzire Taxi for Outstation travel with AC comfort, experienced chauffeurs, transparent pricing, and reliable long-distance service."
  },
  {
    "name": "Swift Dzire Cab for Corporate Employees",
    "description": "Book Swift Dzire Cab for Corporate Employees with punctual service, comfortable vehicles, professional drivers, and reliable employee transportation solutions."
  },
  {
    "name": "Cab Services for Corporate Events",
    "description": "Choose Cab Services for Corporate Events with premium vehicles, professional chauffeurs, flexible scheduling, and smooth transportation management."
  },
  {
    "name": "Velocity Cabs",
    "description": "Velocity Cabs provides Swift Dzire rental services in Pune with professional drivers, clean vehicles, airport pickup, corporate travel, and outstation cab solutions."
  },
  {
    "name": "Swift Dzire Rental Pune",
    "description": "Book Swift Dzire Rental Pune for affordable and comfortable travel with well-maintained sedan cars, experienced chauffeurs, and flexible rental options."
  },
  {
    "name": "Swift Dzire Cab in Pune",
    "description": "Hire Swift Dzire Cab in Pune for local rides, airport transfers, corporate travel, and outstation journeys with reliable service."
  },
  {
    "name": "Swift Dzire Car Hire Pune",
    "description": "Choose Swift Dzire Car Hire Pune for business trips, family travel, events, and personal transportation with professional drivers."
  },
  {
    "name": "Swift Dzire Taxi Service Pune",
    "description": "Book Swift Dzire Taxi Service Pune for safe and comfortable travel with affordable fares, AC vehicles, and experienced chauffeurs."
  },
  {
    "name": "Book Swift Dzire Cab Pune",
    "description": "Book Swift Dzire Cab Pune online with instant confirmation, flexible pickup locations, clean vehicles, and reliable driver support."
  },
  {
    "name": "Swift Dzire Car Rental Pune",
    "description": "Reserve Swift Dzire Car Rental Pune for local and outstation travel with affordable pricing, comfortable interiors, and professional service."
  },
  {
    "name": "Swift Dzire Cab Booking Pune",
    "description": "Complete Swift Dzire Cab Booking Pune for airport rides, corporate travel, family trips, and daily transportation needs."
  },
  {
    "name": "Swift Dzire Sedan Cab Pune",
    "description": "Book Swift Dzire Sedan Cab Pune for economical and comfortable travel with AC facilities, experienced drivers, and smooth rides."
  },
  {
    "name": "Cheap Swift Dzire on Rent Pune",
    "description": "Hire Cheap Swift Dzire on Rent Pune with budget-friendly fares, clean vehicles, professional chauffeurs, and reliable cab service."
  },
  {
    "name": "Swift Dzire Cab Service Pune",
    "description": "Choose Swift Dzire Cab Service Pune for local travel, airport transfers, corporate trips, and outstation transportation."
  },
  {
    "name": "Swift Dzire Outstation Cab Pune",
    "description": "Book Swift Dzire Outstation Cab Pune for long-distance journeys with comfortable seating, fixed pricing, and experienced drivers."
  },
  {
    "name": "Swift Dzire Airport Pickup Pune",
    "description": "Reserve Swift Dzire Airport Pickup Pune for timely airport transfers with professional chauffeurs, luggage support, and comfortable rides."
  },
  {
    "name": "Swift Dzire Taxi Fare Pune",
    "description": "Check Swift Dzire Taxi Fare Pune with transparent pricing, affordable packages, multiple travel options, and no hidden charges."
  }
],

"tableData": [
  ["Swift Dzire on Rent in Pune", "Dzire on Rent for Outstation"],
  ["Per Km Rate for Swift Dzire Cab", "Dzire Per Km Rate for Cab Booking"],
  ["Swift Dzire Per Km Rate in Pune", "Swift Dzire Rent Per Km Rate for Outstation"],
  ["Swift Dzire Rent Per Day", "Swift Dzire Taxi Rate Per Km"],
  ["Pune to Mahabaleshwar Swift Dzire Tour", "Pune to Shirdi Swift Dzire Cab"],
  ["Pune to Lonavala Swift Dzire Cab", "Pune to Ashtavinayak Swift Dzire Cab"],
  ["Pune to Mumbai Airport Swift Dzire Cab", "Pune to Goa Swift Dzire Hire"],
  ["Pune to Bhimashankar Swift Dzire Taxi", "Swift Dzire Taxi for Outstation"],
  ["Swift Dzire Cab for Corporate Employees", "Cab Services for Corporate Events"],
  ["Velocity Cabs", "Swift Dzire on Rent in Pune"],
  ["Swift Dzire Rental Pune", "Swift Dzire Cab in Pune"],
  ["Swift Dzire Car Hire Pune", "Swift Dzire Taxi Service Pune"],
  ["Book Swift Dzire Cab Pune", "Swift Dzire Car Rental Pune"],
  ["Swift Dzire Cab Booking Pune", "Swift Dzire Sedan Cab Pune"],
  ["Cheap Swift Dzire on Rent Pune", "Swift Dzire Cab Service Pune"],
  ["Swift Dzire Outstation Cab Pune", "Swift Dzire Airport Pickup Pune"],
  ["Swift Dzire Taxi Fare Pune", ""]
],





whychoose: [
  {
    WhyChooseheading: "Affordable Swift Dzire on Rent in Pune",
    WhyChoosedescription: "Trustline Cab provides Swift Dzire rental services in Pune with comfortable seating, excellent mileage, professional drivers, and budget-friendly travel solutions."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Pune",
    WhyChoosedescription: "Get Swift Dzire pickup from Pune Airport, railway station, Hinjewadi, Wakad, Baner, Kharadi, Viman Nagar, Pimpri Chinchwad, and other locations."
  },
  {
    WhyChooseheading: "Comfortable Sedan for Every Journey",
    WhyChoosedescription: "Swift Dzire offers a smooth ride, spacious interiors, and luggage space, making it suitable for city travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Professional Chauffeur Driven Service",
    WhyChoosedescription: "Our experienced drivers provide safe, punctual, and comfortable travel with excellent knowledge of Pune city and highway routes."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Hire Swift Dzire for hourly rental, daily packages, one-way trips, round trips, corporate travel, and outstation journeys."
  },
  {
    WhyChooseheading: "Well-Maintained Swift Dzire Fleet",
    WhyChoosedescription: "All Swift Dzire cars are regularly serviced and maintained to provide a clean, reliable, and comfortable travel experience."
  },
  {
    WhyChooseheading: "Ideal for Business & Personal Travel",
    WhyChoosedescription: "Swift Dzire rental is perfect for office travel, airport pickup-drop, family trips, local sightseeing, and economical outstation travel."
  },
  {
    WhyChooseheading: "24/7 Swift Dzire Booking Support",
    WhyChoosedescription: "Book Swift Dzire on rent anytime in Pune with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Swift Dzire on Rent in Pune?",
    answer: "Yes, Trustline Travels offers Swift Dzire rental services in Pune for local travel, airport transfers, corporate trips, and outstation journeys."
  },
  {
    question: "Can I hire Swift Dzire with a driver in Pune?",
    answer: "Yes, chauffeur-driven Swift Dzire rental services are available for safe and comfortable travel."
  },
  {
    question: "How many passengers can travel in Swift Dzire?",
    answer: "Swift Dzire is a comfortable sedan suitable for small families, business travelers, and passengers with luggage."
  },
  {
    question: "Where can I get Swift Dzire pickup in Pune?",
    answer: "Pickup is available from Pune Airport, railway station, hotels, offices, residential areas, and major locations across Pune."
  },
  {
    question: "Can I book Swift Dzire for outstation trips from Pune?",
    answer: "Yes, Swift Dzire is available for destinations like Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, and other outstation routes."
  },
  {
    question: "Is Swift Dzire available for airport transfers?",
    answer: "Yes, Swift Dzire rental services are available for Pune Airport pickup and drop with professional drivers."
  },
  {
    question: "What rental options are available for Swift Dzire?",
    answer: "You can hire Swift Dzire on hourly, daily, one-way, round-trip, and customized rental packages."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Can I book Swift Dzire for corporate travel?",
    answer: "Yes, Swift Dzire rental is suitable for corporate meetings, employee travel, client visits, and daily office transportation."
  },
  {
    question: "How can I book Swift Dzire On Rent in Pune with Trustline Travels?",
    answer: "Share your pickup location, destination, travel date, duration, passenger details, and requirements to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback: "We hired Swift Dzire on rent in Pune for an outstation trip. The car was clean, comfortable, and the driver provided excellent service throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Desai",
    feedback: "Trustline Travels provided a smooth and affordable Swift Dzire rental experience. The booking was quick, the driver was professional, and the ride was comfortable.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/swift-dzire-on-rent-in-pune.webp",
  "description":
    "Book Swift Dzire On Rent in Pune with Trustline Travels for safe, comfortable, and affordable sedan taxi services. We provide Swift Dzire cabs for local travel, outstation trips, airport transfers, corporate travel, one-way and round-trip journeys from Pune with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/swift-dzire-on-rent-in-pune"
  }
};








  return (
    <div>
<Helmet>
  <title>Swift Dzire On Rent in Pune | Sedan Cab | +91 8087080034</title>

  <meta
    name="description"
    content="Book Swift Dzire On Rent in Pune with Trustline Travels for affordable sedan taxi services. Hire Swift Dzire for local travel, outstation trips, airport transfers, corporate travel, Pune to Mahabaleshwar, Pune to Shirdi, and one-way or round-trip journeys with 24x7 availability."
  />

  <meta
    name="keywords"
    content="Swift dzire on rent in Pune, dzire on rent for outstation, per km rate for swift dzire cab, dzire per km rate for cab booking, Swift dzire per km rate in Pune, Swift dzire rent per km rate for outstation, Swift dzire rent per day, Swift dzire taxi rate per km, pune to mahabaleshwar swift dzire tour, pune to shirdi swift dzire, Swift Dzire On Rent in Pune, Swift Dzire Cab Booking Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;